"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.getColumns = void 0;
require("@veeam/components");
const components_1 = require("../../../../components");
require("../../../../core");
const types_1 = require("../types");
const configurationBackupRestorePointTypeCellRenderer_1 = require("./configurationBackupRestorePointTypeCellRenderer");
const getColumns = (texts) => {
    return [
        {
            id: types_1.AvailableRestorePointsGridColumn.instanceId,
            sortKey: types_1.AvailableRestorePointsGridColumn.instanceId,
            title: texts.instanceId,
            cell: (data) => data.instanceId,
        },
        {
            id: types_1.AvailableRestorePointsGridColumn.size,
            sortKey: types_1.AvailableRestorePointsGridColumn.size,
            title: texts.size,
            width: 120,
            cell: components_1.cellRendererAdapter(types_1.AvailableRestorePointsGridColumn.size, components_1.bytesCellRenderer()),
        },
        {
            id: types_1.AvailableRestorePointsGridColumn.productVersion,
            sortKey: types_1.AvailableRestorePointsGridColumn.productVersion,
            title: texts.productVersion,
            width: 180,
            cell: (data) => data.productVersion,
        },
        {
            id: types_1.AvailableRestorePointsGridColumn.creationTimeUtc,
            sortKey: types_1.AvailableRestorePointsGridColumn.creationTimeUtc,
            title: texts.creationTime,
            width: 180,
            cell: components_1.cellRendererAdapter(types_1.AvailableRestorePointsGridColumn.creationTimeUtc, components_1.datetimeCellRenderer()),
        },
        {
            id: types_1.AvailableRestorePointsGridColumn.type,
            sortKey: types_1.AvailableRestorePointsGridColumn.type,
            title: texts.type,
            width: 160,
            cell: configurationBackupRestorePointTypeCellRenderer_1.configurationBackupRestorePointTypeCellRenderer({
                texts: {
                    manual: texts.manualType,
                    schedule: texts.scheduleType,
                },
            }),
        },
    ];
};
exports.getColumns = getColumns;
//# sourceMappingURL=getColumns.js.map